module.exports = __webpack_public_path__ + "media/images/complete-9e37cd6cb277a51720a5c7a88d8683b1.png";